import { BacklogContract } from '../domain/contracts/backlog_contract';
import { BacklogStorageEntity } from '../domain/entities/backlog_storage_entity';
import { BacklogFulfillmentEntity } from '../domain/entities/backlog_fulfillment_entity';
import http from "../../../plugins/http-common";

export const HttpBacklogRepository = {
  ...BacklogContract,
  model_storage: BacklogStorageEntity,
  model_fulfillment: BacklogFulfillmentEntity,

  async backlog_storage(date) {
    const res = await http.get(`backlog_storage?date=${date}`);

    return res;
  },

  async backlog_fulfillment(date) {
    const res = await http.get(`backlog_fulfillment?date=${date}`);

    return res;
  },

  async backlog_show_ff_details(client_name, cod_type, ff_type) {
    const res = await http.get(`backlog_show_fulfillments?client_name=${client_name}&cod_type=${cod_type}&ff_type=${ff_type}`)

    return res;
  }
};